
        var result = require("!!../../../../../node_modules/css-loader/index.js!./create-edit-whitelabel-modal.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/whitelabels/create-edit-whitelabel-modal/create-edit-whitelabel-modal.component.css
// module id = 693
// module chunks = 0